import { Injectable } from '@angular/core';

import { IntegrationsApiService } from '@core/integrations-http-legacy';
import { IntegrationKinds } from '@core/integrations-types';

@Injectable({ providedIn: 'root' })
export class TeamsApiService extends IntegrationsApiService {
  public context: string = IntegrationKinds.TEAMS;
}
